export default __webpack_public_path__ + "static/it-ukraine-association-logo-3ca1ffcd96ef483f3de900fc807c4550.svg";